import React from 'react';
import Modal from './Modal';

class AssignModal extends React.Component {
  constructor(props) {
    super(props);
    this.buttonText = props.state.meta.i18n.button_text;
    this.state = { isVisible: false };
    this.toggleContainer = this.toggleContainer.bind(this);
  }

  componentDidMount() {
    pubsub.subscribe('assignModal:toggle', this.toggleContainer);
  }

  componentWillUnmount() {
    pubsub.unsubscribe('assignModal:toggle', this.toggleContainer);
  }

  toggleContainer() {
    this.setState(state => ({ isVisible: !state.isVisible }));
  }

  render() {
    const { isVisible } = this.state;
    return (
      <div className="AssignModal">
        <button
          type="button"
          children={this.buttonText}
          className="AssignModal-button NewButton NewButton--wide"
          onClick={this.toggleContainer}
        />
        {isVisible && (
          <Modal
            toggleContainer={this.toggleContainer}
            {...this.props}
            timeZones={this.props.timeZones}
          />
        )}
      </div>
    );
  }
}

export default AssignModal;
